import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { CaskSubSubLocation } from "@/app/services/generated/casklocationService";
import { caskLocationService } from "@/app/services/generated/casklocationService";

// Singleton cache store
const caskSubSubLocationsCacheStore = new EntityCacheStore<CaskSubSubLocation>(
  EnumCacheEntityType.caskSubSubLocation,
  async () => caskLocationService.getAllCaskSubSubLocations()
);

// Ephemeral reader
export default class CaskSubSubLocationsCache extends EntityWithGuidKeyCache<CaskSubSubLocation> {
  constructor() {
    super(caskSubSubLocationsCacheStore, (x) => x.id);
  }
}
